import { render, staticRenderFns } from "./PetBreed.vue?vue&type=template&id=7caef124&scoped=true"
import script from "./PetBreed.vue?vue&type=script&lang=js"
export * from "./PetBreed.vue?vue&type=script&lang=js"
import style0 from "./PetBreed.vue?vue&type=style&index=0&id=7caef124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caef124",
  null
  
)

export default component.exports